import {action, computed, observable, makeObservable} from 'mobx';
import {ContainersCollection} from './ContainersCollection';
import {ContainersCond} from './ContainersCond';
import {Field} from '../../Common/stores/Field';

export class ContainersField extends Field {
    // Containers Observable variables
    @observable container;
    @observable active;
    @observable isOrOp; // is Or Operation (Options: Or=True/And=False)
    @observable conds;
    @observable containerDataReceived;
    @observable islink;
    @observable hyperlink;

    // Containers variables
    message;
    engmessage;
    isNewContainer;

    constructor(field, parentField) {
        super(field, parentField);
        makeObservable(this);
        this.setContainerID(field.container);
        this.conds = observable.array([]);
        this.collection = new ContainersCollection(parentField.collection);
    }

    setCollection(field) {
        field.fields && this.collection.insertFields(this, field.fields);
    }

    initContainerField(data, numOfInputs?) {
        this.title = data.title;
        this.setIsOrOp(data.isOrOp);
        this.message = data.message;
        this.engmessage = data.engmessage;

        this.setHyperlink(data.hyperlink);
        this.setIslink(data.islink);

        this.conds.splice(0, this.conds.length);

        data.conds.forEach((cond, index) => {
            const newCond = new ContainersCond(cond, index);
            this.addCond(newCond);
        });

        // Last one is newCond - not from data
        this.addCond(this.createNewCond());

        this.setActive(data.active);

        this.isNewContainer = data.isNewContainer;
        this.setContainerDataReceived(true);
    }

    @computed get isContainer() {
        return this.container !== undefined;
    }

    // TODO: find another way to mark uninitial
    @computed get hasContainerData() {
        return this.active !== undefined;
    }

    @action setHyperlink(url) {
        this.hyperlink = url;
    }

    @action setActive(active) {
        this.active = active;
    }

    @action setIsOrOp(value) {
        this.isOrOp = value;
    }

    @action setIslink(islink) {
        this.islink = islink;
    }

    @action setContainerDataReceived(value) {
        this.containerDataReceived = value;
    }

    createNewCond() {
        return new ContainersCond(
            {field: '', operator: '380', value: '', secvalue: ''},
            this.conds.length === 0 ? this.conds.length : this.conds[this.conds.length - 1].id + 1
        );
    }

    @action addCond(cond) {
        this.conds.push(cond);
    }

    @action deleteCond(cond) {
        this.conds.remove(cond);

        if (this.conds.length === 0) {
            this.addCond(this.createNewCond());
        }
    }

    @computed get maxInputsInScreen() {
        if (this.conds.some(cond => cond.numOfInputs === 2)) {
            return 2;
        } else if (this.conds.some(cond => cond.numOfInputs === 1)) {
            return 1;
        } else {
            return 0;
        }
    }

    @action setContainerID(containerID) {
        this.container = containerID;
        this.name = containerID;
    }

    removeAllUninitializedConds() {
        this.conds.forEach(cond => {
            // eslint-disable-next-line
            if (cond.fieldToShowSelected == 0 || cond.fieldToShowSelected === '') {
                this.conds.remove(cond);
            }
        });
    }
}
